import * as u from './utils';
import { debounce } from 'throttle-debounce';

export default () => {
    const banners = document.querySelectorAll('.banner__items');
    const currentUrl = window.location.host + window.location.pathname;

    if (!banners) {
        return;
    }

    const handleScroll = () => {
        for (const el of banners) {
            const links = Array.prototype.slice.call(el.querySelectorAll('.banner__link')).reverse();
            u.removeClass(links, 'is-active');

            for (const link of links) {
                const url = new URL(link.href);

                if (!url.hash || currentUrl !== url.host + url.pathname) {
                    continue;
                }

                const target = document.querySelector(url.hash);
                if (!target) {
                    continue;
                }

                const offset = window.pageYOffset + window.innerHeight * 0.7;

                if (target.offsetTop < offset) {
                    u.addClass(link, 'is-active');
                    break;
                }
            }
        }
    };

    handleScroll();
    window.addEventListener('scroll', debounce(50, handleScroll));
};
